module.exports = __webpack_public_path__ + "img/gb.2e9c71c7.svg";